<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    :isCustomSaving="loading"
    :inputs="inputs"
    @save="save"
  >
    <template #squaresDataSource.input="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="selectedDataSource.datasource" @change="selectedDataSourceChanged = true" />
      </v-col>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'MasterplanSquaresTwoSettings',
  components: { AdminWrapper, DataInput },
  computed: {
    additionalModuleName: get('admin/additionalModules@MASTERPLAN_2_SQUARES_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@masterplan_2_squares_module_enabled'),
    moduleEnabler() {
      return {
        name: 'masterplan_2_squares_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle2', { suffix: this.additionalModuleName }),
      };
    },
    moduleDataSourceSettingsName() {
      return 'masterplan_2_squares_datasource';
    },
    dataSources: get('layers/metadata'),
    dataSourcesMapped() {
      return this.$_objectToArray(this.dataSources).filter(
        dataSource => dataSource.scope === 'core' && !dataSource.module
      );
    },
    inputs() {
      return [
        {
          name: 'squaresDataSource',
          translationPath: 'admin.masterplanSquares.squaresDataSource',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          items: this.dataSourcesMapped,
          itemText: 'verbose_name',
          itemValue: 'name',
        },
      ];
    },
  },
  data: () => ({
    isFormFetched: false,
    loading: false,
    selectedDataSource: {
      datasource: '',
    },
    selectedDataSourceChanged: false,
  }),
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getDataSourceSettings: call('datasourceSettings/getDatasourceSettings'),
    editDataSourceSettings: call('datasourceSettings/editDatasourceSettings'),
    async init() {
      await Promise.all([
        this.getDataSources({ with_attributes_schema: true }),
        ...(this.isModuleEnabled ? [this.updateSelectedDataSource()] : []),
      ]);
      this.isFormFetched = true;
    },
    async save() {
      if (!this.selectedDataSourceChanged) {
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
        return;
      }
      this.loading = true;
      try {
        const payload = { name: this.moduleDataSourceSettingsName, settings: this.selectedDataSource };
        await this.editDataSourceSettings(payload);
        this.selectedDataSourceChanged = false;
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successEditSetting'),
        });
      } finally {
        this.loading = false;
      }
    },
    async updateSelectedDataSource() {
      try {
        const r = await this.getDataSourceSettings(this.moduleDataSourceSettingsName);
        this.selectedDataSource = { datasource: r.datasource };
      } catch {
        this.selectedDataSource = {
          datasource: '',
        };
      } finally {
        this.selectedDataSourceChanged = false;
      }
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
